import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogModule,
} from '@angular/material/legacy-dialog';
import { MatLegacyTableModule } from '@angular/material/legacy-table';

import {
  StringTransformationPipe,
  StringTransformationType,
} from 'v2/modules/shared/pipes/string-transformation.pipe';
import { trackById } from 'v2/modules/shared/util/track-by.util';

import { ISalesOrderShipment } from './../../../order/interfaces/order.interface';

@Component({
  selector: 'lum-sales-order-shipment-status-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatLegacyDialogModule,
    MatLegacyTableModule,
    StringTransformationPipe,
  ],
  templateUrl: './sales-order-shipment-status-dialog.component.html',
  styleUrls: ['./sales-order-shipment-status-dialog.component.scss'],
})
export class SalesOrderShipmentStatusDialogComponent {
  stringTransformationType = StringTransformationType;
  trackById = trackById;
  constructor(
    private dialogRef :MatDialogRef<SalesOrderShipmentStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data :{
      salesOrderShipments :ISalesOrderShipment[];
      ftPushUnPushToFulfilllmentChannel :boolean;
    },
  ) {}
}
